import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { CarModelTypeService } from 'src/app/car-model-type/car-model-type.service';
import { InfoRow } from 'src/typings';

@Component({
  selector: 'app-add-info-row',
  templateUrl: './add-info-row.component.html',
  styleUrls: ['./add-info-row.component.scss']
})
export class AddInfoRowComponent {
  @Input() car_id: number | undefined;

  @Input() row_id: number | undefined;

  @Input() set description(description: string) {
    this.createForm.controls.description.setValue(description);
  }

  @Input() set value(value: string) {
    this.createForm.controls.value.setValue(value);
  }

  @Output() changeEvent: EventEmitter<InfoRow[]> = new EventEmitter();

  constructor(private fb: UntypedFormBuilder, private carModelTypeService: CarModelTypeService) {}

  createForm = this.fb.group({
    description: new UntypedFormControl(),
    value: new UntypedFormControl()
  });

  loading = false;

  editRow() {
    if (this.row_id) {
      this.loading = true;
      this.carModelTypeService
        .updateInfoRow({
          id: this.row_id,
          description: this.createForm.value.description,
          value: this.createForm.value.value
        })
        .subscribe((data) => {
          this.loading = false;
          this.changeEvent.emit(data);
        });
    }
  }

  addRow() {
    if (this.row_id) {
      this.editRow();
      return;
    }
    if (this.car_id) {
      this.loading = true;
      this.carModelTypeService
        .addInfoRow({
          description: this.createForm.value.description,
          value: this.createForm.value.value,
          car_id: this.car_id
        })
        .subscribe((data) => {
          this.loading = false;
          this.changeEvent.emit(data);
        });
    }
  }
}
